import { render, staticRenderFns } from "./LpColorDropDown.vue?vue&type=template&id=6b18244c&scoped=true"
import script from "./LpColorDropDown.vue?vue&type=script&lang=js"
export * from "./LpColorDropDown.vue?vue&type=script&lang=js"
import style0 from "./LpColorDropDown.vue?vue&type=style&index=0&id=6b18244c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b18244c",
  null
  
)

export default component.exports